// QR codes with a GS1 Digital Link (e.g. https://hui-snl.nl/8003/087211614040956113042382240606) are stored and
// matched as the GS1 element string without brackets: the Application Identifier followed by its value
// (8003087211614040956113042382240606). This is the barcode IDL expects. Any domain and path prefix before the AI is
// accepted, a query string, fragment and trailing slash are ignored. Only these AI's are recognized:
// - 8003 (GRAI): 14 digits plus a serial number of 0 to 16 characters
// - 00 (SSCC): 18 digits
// - 01 (GTIN): 14 digits, optionally followed by /21/<serial number> (1 to 20 characters)
// The result is in upper case, like the other barcodes in Veloyd (manual input in the scanners is upper case).
const digitalLinkRegExp = /^https?:\/\/[^/?#\s]+(?:\/[^?#\s]*)?\/(8003|00|01)\/([^/?#\s]+)(?:\/21\/([^/?#\s]+))?\/?(?:[?#]\S*)?$/i

function decode(value: string): string | null {
    try {
        return decodeURIComponent(value)
    } catch {
        return null
    }
}

/**
 * Converts a GS1 Digital Link URL to the barcode of the collo (AI + value), other values are returned unchanged.
 */
export function gs1DigitalLinkToBarcode<T>(value: T): T | string {
    if (typeof value !== 'string') {
        return value
    }

    const match = value.trim().match(digitalLinkRegExp)

    if (!match) {
        return value
    }

    const ai = match[1]
    const aiValue = decode(match[2])
    const serial = match[3] !== undefined ? decode(match[3]) : undefined

    if (aiValue === null || serial === null) {
        return value
    }

    if (ai === '8003' && serial === undefined && /^\d{14}/.test(aiValue) && aiValue.length <= 30) {
        return `${ai}${aiValue}`.toUpperCase()
    }

    if (ai === '00' && serial === undefined && /^\d{18}$/.test(aiValue)) {
        return `${ai}${aiValue}`
    }

    if (ai === '01' && /^\d{14}$/.test(aiValue) && (serial === undefined || (serial.length >= 1 && serial.length <= 20))) {
        return `${ai}${aiValue}${serial !== undefined ? `21${serial}` : ''}`.toUpperCase()
    }

    return value
}

export default gs1DigitalLinkToBarcode
